export default function Wrapper({ children }) {
  return <div className="auth__wrapper">
    {children}
  </div>
}
